import {
    PriceComparisonAddRequest, PriceComparisonDeleteRequest, PriceComparisonEditRequest,
    PriceComparisonGetRequest,
} from '@dave/types';
import { createAction, props } from '@ngrx/store';
import { UploadActionProps } from '../../guards/resolver.helper';
import { GatewayResponseErrorType } from '../../services/app-gateway.service';
import { PriceComparisonEntity } from '../../entities/price-comparison.entity';


const prefix = 'data/' + 'priceComparison/';
export const PriceComparisonActionTypes = {
    Load: createAction(prefix + 'load', props<{ Payload: PriceComparisonGetRequest }>()),
    Change: createAction(prefix + 'change', props<{ Payload: PriceComparisonEditRequest }>()),
    Delete: createAction(prefix + 'delete', props<{ Payload: PriceComparisonDeleteRequest }>()),

    // UpdateAll: createAction(prefix + 'updateAll', props<{ Payload: Array<PriceComparisonEntity>; updateLatestUpdatedAt?: boolean }>()),
    // UpdateMany: createAction(prefix + 'updateMany', props<{ Payload: Array<PriceComparisonEntity>; updateLatestUpdatedAt?: boolean }>()),
    // UpdateOne: createAction(prefix + 'updateOne', props<{ Payload: PriceComparisonEntity }>()),
    // RemoveOne: createAction(prefix + 'remove', props<{ Payload: number }>()),

    CreateRequest: createAction(prefix + 'create/request', props<{ Payload: PriceComparisonAddRequest }>()),
    CreateSuccess: createAction(prefix + 'create/success', props<{ Payload: PriceComparisonEntity }>()),
    CreateFailure: createAction(prefix + 'create/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),
};
